import { render, staticRenderFns } from "./NewPasswordModal.vue?vue&type=template&id=0d770c90"
import script from "./NewPasswordModal.vue?vue&type=script&lang=js"
export * from "./NewPasswordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports